import * as THREE from 'three'
import Project from './Project'
import TweenLite from 'gsap/TweenLite'

import projectsNuvolaPOSSlideASources from '../../../models/projects/nuvolaPOS/slideA.jpg'
import projectsNuvolaPOSSlideBSources from '../../../models/projects/nuvolaPOS/slideB.jpg'
import projectsNuvolaPOSSlideCSources from '../../../models/projects/nuvolaPOS/slideC.jpg'

import projectsStockMarketSlideASources from '../../../models/projects/stockMarket/slideA.jpg'
import projectsStockMarketSlideBSources from '../../../models/projects/stockMarket/slideB.jpg'
import projectsStockMarketSlideCSources from '../../../models/projects/stockMarket/slideC.jpg'

import projectsCodeGenSlideASources from '../../../models/projects/codeGenerator/slideA.jpg'
import projectsCodeGenSlideBSources from '../../../models/projects/codeGenerator/slideB.jpg'
import projectsCodeGenSlideCSources from '../../../models/projects/codeGenerator/slideC.jpg'

import projectsVoiceAssistSlideASources from '../../../models/projects/voiceAssistant/slideA.jpg'
import projectsVoiceAssistSlideBSources from '../../../models/projects/voiceAssistant/slideB.jpg'
import projectsVoiceAssistSlideCSources from '../../../models/projects/voiceAssistant/slideC.jpg'

import projectsVehicleCtrlSlideASources from '../../../models/projects/vehicleControl/slideA.jpg'
import projectsVehicleCtrlSlideBSources from '../../../models/projects/vehicleControl/slideB.jpg'
import projectsVehicleCtrlSlideCSources from '../../../models/projects/vehicleControl/slideC.jpg'

import projectsMetaVulnerSlideASources from '../../../models/projects/metaVulnerability/slideA.jpg'
import projectsMetaVulnerSlideBSources from '../../../models/projects/metaVulnerability/slideB.jpg'
import projectsMetaVulnerSlideCSources from '../../../models/projects/metaVulnerability/slideC.jpg'

import projectsFeastifySlideASources from '../../../models/projects/feastify/slideA.jpg'
import projectsFeastifySlideBSources from '../../../models/projects/feastify/slideB.jpg'
import projectsFeastifySlideCSources from '../../../models/projects/feastify/slideC.jpg'



export default class ProjectsSection {
    constructor(_options) {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Debug
        if (this.debug) {
            this.debugFolder = this.debug.addFolder('projects')
            this.debugFolder.open()
        }

        // Set up
        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        // this.setGeometries()
        this.setMeshes()
        this.setList()
        this.setZone()

        // Add all project from the list
        for (const _options of this.list) {
            this.add(_options)
        }
    }

    setGeometries() {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneBufferGeometry(16, 8)
    }

    setMeshes() {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setList() {
        this.list = [
            {
                name: 'Feastify',
                imageSources:
                    [
                        projectsFeastifySlideASources,
                        projectsFeastifySlideBSources,
                        projectsFeastifySlideCSources
                    ],
                floorTexture: this.resources.items.projectsFeastifyFloorTexture,
                link:
                {
                    href: 'https://feastify.app/',
                    x: - 2.4,
                    y: - 5.5,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'fwa', x: 3.95, y: 4.15 }
                    ]
            },
            {
                name: 'Stock Market',
                imageSources:
                    [
                        projectsStockMarketSlideASources,
                        projectsStockMarketSlideBSources,
                        projectsStockMarketSlideCSources
                    ],
                floorTexture: this.resources.items.projectsStockMarketFloorTexture,
                link:
                {
                    href: 'https://github.com/lilaavinoth/Stock-market-prediction.git',
                    x: - 2.7,
                    y: - 5,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'fwa', x: 3.95, y: 4.15 }
                    ]
            },
            {
                name: 'Voice Assistant',
                imageSources:
                    [
                        projectsVoiceAssistSlideASources,
                        projectsVoiceAssistSlideBSources,
                        projectsVoiceAssistSlideCSources
                    ],
                floorTexture: this.resources.items.projectsVoiceAssistantFloorTexture,
                link:
                {
                    href: 'https://youtu.be/n-xkd93p9A8?si=NrJFyIyLLxMTyLk2&t=7',
                    x: - 2.6,
                    y: - 5.3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'awwwards', x: 3.95, y: 4.15 },
                        // { type: 'fwa', x: 5.6, y: 4.15 },
                        // { type: 'cssda', x: 7.2, y: 4.15 }
                    ]
            },
            {
                name: 'Meta Vulnerability',
                imageSources:
                    [
                        projectsMetaVulnerSlideASources,
                        projectsMetaVulnerSlideBSources,
                        projectsMetaVulnerSlideCSources
                    ],
                floorTexture: this.resources.items.projectsMetaVulnerabilityFloorTexture,
                link:
                {
                    href: 'https://youtu.be/MxUrR2ef2s4?si=zli6lCkxlfJzkDxp&t=196',
                    x: - 3.5,
                    y: - 7,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'awwwards', x: 3.95, y: 4.15 },
                        // { type: 'fwa', x: 5.6, y: 4.15 }
                    ]
            },
            {
                name: 'Nuvola POS',
                imageSources:
                    [
                        projectsNuvolaPOSSlideASources,
                        projectsNuvolaPOSSlideBSources,
                        projectsNuvolaPOSSlideCSources
                    ],
                floorTexture: this.resources.items.projectsNuvolaPOSFloorTexture,
                link:
                {
                    href: 'https://nuvolapos.com/',
                    x: - 1.7,
                    y: - 6.6,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                    ]
            },
            {
                name: 'Code Generator',
                imageSources:
                    [
                        projectsCodeGenSlideASources,
                        projectsCodeGenSlideBSources,
                        projectsCodeGenSlideCSources
                    ],
                floorTexture: this.resources.items.projectsCodeGeneratorFloorTexture,
                link:
                {
                    href: 'https://youtu.be/N1eH1sstQ_o?si=zotlsdsGRr9SBVDB&t=47',
                    x: - 2.2,
                    y: - 6.5,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'awwwards', x: 3.95, y: 4.15 },
                        // { type: 'fwa', x: 5.6, y: 4.15 },
                        // { type: 'cssda', x: 7.2, y: 4.15 }
                    ]
            },
            {
                name: 'Vehicle Control',
                imageSources:
                    [
                        projectsVehicleCtrlSlideASources,
                        projectsVehicleCtrlSlideBSources,
                        projectsVehicleCtrlSlideCSources
                    ],
                floorTexture: this.resources.items.projectsVehicleControlFloorTexture,
                link:
                {
                    href: 'https://youtu.be/nUrQmHOe6uE?si=rcv9towO0NgABhp6&t=191',
                    x: - 2.7,
                    y: - 6.4,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                    [
                        // { type: 'awwwards', x: 3.95, y: 4.15 },
                        // { type: 'fwa', x: 5.6, y: 4.15 },
                        // { type: 'cssda', x: 7.2, y: 4.15 }
                    ]
            },
            // {
            //     name: 'JobX',
            //     imageSources:
            //     [
            //         projectsJobXSlideASources,
            //         projectsJobXSlideBSources,
            //         projectsJobXSlideCSources
            //     ],
            //     floorTexture: this.resources.items.projectsJobXFloorTexture,
            //     link:
            //     {
            //         href: 'https://contact.lilaavinoth.com/',
            //         x: - 2.2,
            //         y: - 4.5,
            //         halfExtents:
            //         {
            //             x: 3.2,
            //             y: 1.5
            //         }
            //     },
            //     hidden: true,
            //     distinctions:
            //     [
            //         // { type: 'awwwards', x: 3.95, y: 4.15 },
            //         // { type: 'fwa', x: 5.6, y: 4.15 },
            //         // { type: 'cssda', x: 7.2, y: 4.15 }
            //     ]
            // },
        ]
    }

    setZone() {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: this.x + totalWidth - this.projectHalfWidth - 6, y: this.y },
            halfExtents: { x: totalWidth, y: 12 },
            data: { cameraAngle: 'projects' }
        })

        zone.on('in', (_data) => {
            this.camera.angle.set(_data.cameraAngle)
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: 0 })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: 0 })
        })

        zone.on('out', () => {
            this.camera.angle.set('default')
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: this.passes.horizontalBlurPass.strength })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: this.passes.verticalBlurPass.strength })
        })
    }

    add(_options) {
        const x = this.x + this.items.length * this.interDistance
        let y = this.y
        if (this.items.length > 0) {
            y += (Math.random() - 0.5) * this.positionRandomess
        }

        // Create project
        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        // Add tiles
        if (this.items.length >= 1) {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x + this.projectHalfWidth, previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        // Save
        this.items.push(project)
    }
}
